/**
 * The varshphal chart check's form props, shared by the server-rendered shell
 * (VarshphalCheckLazy), the island's BirthDetailsForm and
 * BirthToolFormShell.parity.test.tsx, so every frame before and after the
 * island loads reads the same words. No name field: the chart is the seeker's
 * own, and a name adds nothing to it. The birth time is required: the Varsha
 * Lagna moves about one degree every four minutes.
 */
export const VARSHPHAL_FORM = {
  language: "en",
  submitLabel: "Show My Varshphal Chart",
  collectName: false,
  requireBirthTime: true,
} as const;

/**
 * The form's box in every state before the verdict: the shell, the loading
 * shell and the live form each fill it, with the action at its foot, so the
 * place hint or an error appearing above the action moves nothing, not even
 * the action. Its floor is the tallest measured form (VarshphalCheckLazy).
 */
export const VARSHPHAL_FORM_FRAME =
  "mx-auto flex min-h-[620px] w-full max-w-md flex-col sm:min-h-[490px] [&>form]:flex [&>form]:flex-1 [&>form]:flex-col [&>form>:last-child]:mt-auto";

/** The verdict's box: the article's full width, for the chart beside the placements. */
export const VARSHPHAL_VERDICT_FRAME = "flex w-full min-w-0 flex-1 flex-col";

/**
 * The slot's two reserved heights (VarshphalCheckLazy explains the numbers).
 * The form reserve holds from the server HTML and covers every state before a
 * chart: the shell, the live form, its place hint and each error. The verdict
 * reserve is added by the island inside the submit itself, before the request
 * goes out, and holds until "Check another birth".
 */
export const VARSHPHAL_FORM_RESERVE = "min-h-[890px] sm:min-h-[740px]";
export const VARSHPHAL_VERDICT_RESERVE = "min-h-[1840px] sm:min-h-[1630px] md:min-h-[1060px]";

/** The real form's input ids (no heading prop, so BirthDetailsForm's "-default" ids). */
export const VARSHPHAL_FIELD_IDS = {
  date: "birthDate-default",
  time: "birthTime-default",
  place: "birthPlace-default",
} as const;

/** What the chart shows, listed under the form until it is cast. */
export const VARSHPHAL_SHOWS = [
  "The solar return that opens your varsha, and the next one that closes it",
  "Your Varsha Lagna and the annual chart, in North or South Indian style",
  "The Muntha and its lord, and each graha's sign, degree and house",
] as const;

/** What the chart is cast for, and what this page does not calculate. */
export const VARSHPHAL_SCOPE =
  "Cast for your birthplace (the classical rule). Year lord (Varsheshwara), Muddha dasha and Tajik yogas are not calculated here.";
